import React, { Component } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import MenuSetupItem from '../MenuSetupItem';
import store from '../../../../../../../../store/store';
import {
  REORDER_VENDOR_MENU_CATEGORY,
  REORDER_VENDOR_MENU_ITEM_STATUS,
} from '../../../../../../../../store/types';

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  store.dispatch({
    type: REORDER_VENDOR_MENU_CATEGORY,
    payload: result,
  });
  let formData = {
    status: false,
  };
  store.dispatch({
    type: REORDER_VENDOR_MENU_ITEM_STATUS,
    payload: formData,
  });
  // console.log("Result ==> ", result);
  return result;
};

const grid = 2;

class DragAndDropItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: props?.menuCategory || [],
      //getItems(10),
    };
    this.onDragEnd = this.onDragEnd.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.menuCategory !== this.props.menuCategory) {
      this.setState({ items: this.props.menuCategory });
    }
  }

  onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const items = reorder(
      this.state.items,
      result.source.index,
      result.destination.index
    );

    this.setState({
      items,
    });
  }

  // Normally you would want to split things out into separate components.
  // But in this example everything is just done in one place for simplicity
  render() {
    // console.log("menu Item ===>", this.state.items);
    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="droppable" type="droppableItem">
          {(provided, snapshot) => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              {this.state.items.map((item, index) => (
                <Draggable key={item._id} draggableId={item._id} index={index}>
                  {(provided, snapshot) => (
                    <div>
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        // {...provided.dragHandleProps}
                      >
                        {!item.is_temp_local ? (
                          <React.Fragment>
                            <MenuSetupItem
                              category={item}
                              disabled={this.props?.disabled}
                              actionByMain={provided.dragHandleProps}
                              type={'droppableItem'}
                            />
                          </React.Fragment>
                        ) : (
                          <> </>
                        )}
                      </div>
                      {provided.placeholder}
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  }
}

export default DragAndDropItem;
